module.exports = __webpack_public_path__ + "static/media/web.de2cce9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/web.svg
// module id = 256
// module chunks = 0